
export const addDefaultImg = (ev) => {
  ev.target.src = "../assets/images/defaultImage.png" // Ensure this path matches your public/assets setup
  ev.target.onerror = null; // Prevent infinite loop in case default image fails
};